<template>
	<div class="dataAIBox">
		<div class="banner">
			<div class="txt">数据AI板块</div>
		</div>
		<div class="infoBox">
			<div class="title">
				<div class="name">
					<p class="txt">可再生能源大模型</p>
					<i class="line"></i>
				</div>
			</div>
			
			<div class="flexBox item">
				<div class="des" style="padding: 0 9.8rem 0 32.3rem;">
					<div class="txt">AI+可再生能源</div>
					<div class="val">依托张家口国家级可再生能源示范区，探索可再生能源行业大模型，建设涵盖从资源规划、存量管理、企业生产、升级改造，到设备退出的全链路Agent应用，构建可再生能源领域全国最大、质量最高的“高质量数据集-大模型-AI应用”闭环。</div>
				</div>
				<img src="../../../assets/img/dataAI/demo_0.jpg" class="icon">
			</div>
			
			<div class="flexBox item">
				<img src="../../../assets/img/dataAI/demo_1.jpg" class="icon">
				<div class="des"   style="padding: 0 32.3rem 0 9.8rem; text-align: right;">
					<div class="txt">AI+可再生能源</div>
					<div class="val">依托张家口国家级可再生能源示范区，探索可再生能源行业大模型，建设涵盖从资源规划、存量管理、企业生产、升级改造，到设备退出的全链路Agent应用，构建可再生能源领域全国最大、质量最高的“高质量数据集-大模型-AI应用”闭环。</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DataAI',
		components: {

		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/dataAI.css");
</style>